import { Component, AfterViewInit, Input, ElementRef, ViewChild, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

const noop = () => {
};

@Component({
  selector: 'password-input',
  templateUrl: 'password-input.component.html',
  styleUrls: ['../common.styles.scss', 'password-input.component.scss'],
  providers: [
        { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: PasswordInputComponent }
  ]
})
export class PasswordInputComponent implements AfterViewInit, ControlValueAccessor {

  @Output() propertyChanged = new EventEmitter<string>();

  private _value: string;
  private _onChange: (_: any) => void = noop;

  @ViewChild('input') el: ElementRef;
  @ViewChild('toggler') toggler: ElementRef;
  @Input() placeholder: string;
  @Input() isInvalid: boolean;
  @Input() behaviour = 'click';
  @Input() required = false;
  @Input() minlength = 100;
  @Input() maxlength = 200;
  @Input() id : string;
  
  isPasswordVisible = false;

  get value(): any {
    return this._value;
  }

  set value(v: any) {
    if (v !== this._value) {
      this._value = v;
      this._onChange(v);
    }
  }

  ngAfterViewInit() {
    const __this = this;
    const textbox = __this.el.nativeElement;
    const toggler = __this.toggler.nativeElement;

    const togglePassword = () => {
      const currentPosition = textbox.selectionStart;
      __this.isPasswordVisible = !__this.isPasswordVisible;
      textbox.type = __this.isPasswordVisible ? 'text' : 'password';
      // Restore cursor position after type change
      setTimeout(() => {
        textbox.setSelectionRange(currentPosition, currentPosition);
      }, 0);
    };

    // Click/tap to toggle
    toggler.addEventListener('click', (e) => {
      togglePassword();
    });

    // Keyboard accessibility - Enter key
    toggler.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        togglePassword();
      }
      // Space key
      if (e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        togglePassword();
      }
    });
  }

  writeValue(value: any) {
    this._value = value;
  }

  registerOnChange(fn: (value: any) => void) {
    this._onChange = fn;
  }

  registerOnTouched(fn: any) {}

  public focusin() {
    this.propertyChanged.emit('');
  }

}
